<template>
   
   <!-- <div> -->

      <v-footer 
        dark 
        app
        height="45px"
        :class="{ 'grey darken-3': !dark, 'footer': true}"
      >
          <v-btn 
            v-if="!$route.meta.hideFooterHomeNav" 
            icon 
            @click.prevent="goHome"
          >
            <v-icon>mdi-home</v-icon>
          </v-btn>

          <v-spacer></v-spacer>
          
          <v-btn 
            v-if="!$route.meta.hideFooterHomeNav" 
            icon 
            @click.prevent="logout"
          >
            <v-icon>mdi-logout</v-icon>
          </v-btn>

      </v-footer>

   <!-- </div> -->

</template>

<script>
  export default {

    computed: {

      dark () {
        if (localStorage.getItem('darkTheme') === 'true') return true;
        return false;
      },

    },
   

    methods: {

      goHome () {
        // Clear all list position info


        // Go to home page
        this.$router.replace({ name: "Tasks" }).catch(err => {}) 
      },    
      logout () {
        // Call Logout
        this.$store.dispatch('logout')
        .then( (response) => {

          // send user back to login page
          this.$router.push({name: 'signin'})
        })
      },          

    },


  }
</script>

